import MetricDetailTitle from "@/pages/benchmark/pages/metricDetail/components/MetricDetailTitle";
import MetricDetailCardService from "@/pages/benchmark/pages/metricDetail/components/MetricDetailCardService";
import MetricDetailFilter from "@/pages/benchmark/pages/metricDetail/components/MetricDetailFilter";
import MetricDetailChart from "@/pages/benchmark/pages/metricDetail/components/MetricDetailChart";
import MetricDetailChartService from "@/pages/benchmark/pages/metricDetail/components/MetricDetailChartService";
import MetricDetailOperation from "@/pages/benchmark/pages/metricDetail/components/MetricDetailOperation";
import MetricDetailTabService from "@/pages/benchmark/pages/metricDetail/components/MetricDetailTabService";
import MetricDetailCardContext from "@/pages/benchmark/pages/metricDetail/components/MetricDetailCardContext";
import MetricOtdrService from "@/pages/benchmark/pages/metricOtdr/component/MetricOtdrService";
import MetricOtdrContext from "@/pages/benchmark/pages/metricOtdr/component/MetricOtdrContext";
import MetricDetailTips from "@/pages/benchmark/pages/metricDetail/components/MetricDetailTips";

export default {
  MetricDetailFilter,
  MetricDetailCardService,
  MetricDetailTitle,
  MetricDetailCardContext,
  MetricDetailChart,
  MetricDetailChartService,
  MetricDetailOperation,
  MetricDetailTabService,
  MetricOtdrContext,
  MetricOtdrService,
  MetricDetailTips,
};